import { type Client, prefetch } from "@opensea/graphql"
import { type Address, normalizeAddress } from "@opensea/utils"
import { PROFILE_INFO_QUERY } from "@/hooks/api/use-profile-info"

export const prefetchProfilePageLayout = (
  identifier: Address,
  client: Client,
) => {
  prefetch(client, PROFILE_INFO_QUERY, {
    identifier: normalizeAddress(identifier),
  })
}
